import { AnimatePresence, motion } from 'framer-motion'
import { Package } from 'lucide-react'
import { ProductCard } from './ProductCard'
import type { Product } from '@/types'

interface ProductGridProps {
  products: Product[]
  categorySlug?: string
  isLoading?: boolean
}

export function ProductGrid({ products, categorySlug, isLoading }: ProductGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="card animate-pulse">
            <div className="aspect-[4/3] bg-secondary-200" />
            <div className="p-4 space-y-3">
              <div className="h-3 bg-secondary-200 rounded w-1/4" />
              <div className="h-5 bg-secondary-200 rounded w-3/4" />
              <div className="h-4 bg-secondary-200 rounded w-full" />
              <div className="flex gap-2">
                <div className="h-5 bg-secondary-200 rounded w-12" />
                <div className="h-5 bg-secondary-200 rounded w-12" />
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (products.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center py-16"
      >
        <Package className="w-16 h-16 text-secondary-300 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-secondary-900 mb-2">
          No products found
        </h3>
        <p className="text-secondary-500">
          Try adjusting your filters or browse other categories.
        </p>
      </motion.div>
    )
  }

  return (
    <motion.div
      layout
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      <AnimatePresence mode="popLayout">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            categorySlug={categorySlug}
          />
        ))}
      </AnimatePresence>
    </motion.div>
  )
}
